import { dispatch } from "global";
import { TAB_FOCUS_CHANGE } from "global/actions";

export function initTabActiveService() {
    function onVisibilityChange() {
        dispatch({ type: TAB_FOCUS_CHANGE, payload: { focus: document.visibilityState === "visible" } });
    }
    window.addEventListener("visibilitychange", onVisibilityChange, { passive: true });
}
